import { APIcallerv2 } from '@services/APIcaller';

const getBrandsOfClient = async () => APIcallerv2.apiGet('/brands');

export default {
  getBrandsOfClient,
};
